import { GridController } from "../../../../../common/grid/grid.controller";
import watch from 'redux-watch';

/* @ngInject */
export function ProtectiveEquipmentGridController($controller, $ngRedux, $state, $rootScope, NavigationService, ProtectiveEquipmentActions, ProtectiveEquipmentService) {
    var ctrl = this;

    Object.setPrototypeOf(ctrl, new GridController($ngRedux, $state, NavigationService));

    ctrl.$onInit = function() {
        ctrl.module = 'protectiveEquipment';
        ctrl.identifier = 'protectiveEquipmentGrid';
        ctrl.filterTemplate = './protective-equipment-grid-filter.html';
        ctrl.filterControls = './protective-equipment-grid-filter-controls.html';
        ctrl.exportService = ProtectiveEquipmentService.getPersonalEquipment;

        ctrl.columns = [
            {title: '#',                    mapper: null},
            {title: 'Equipment ID',         mapper: 'equipmentId'},
            {title: 'Site Location',        mapper: 'location.name'},
            {title: 'Category',             mapper: 'category.name'},
            {title: 'Type',                 mapper: 'type.name'},
            {title: 'Subtype',              mapper: 'subtype.name'},
            {title: 'Lead Equivalence',     mapper: 'leadEquivalence.getValue'},
            {title: 'Test Status',          mapper: 'testResult'},
            {title: 'Description',          mapper: 'description'}
        ];

        ctrl.unsubscribe = $ngRedux.connect(ctrl.mapState().bind(ctrl), ProtectiveEquipmentActions)(ctrl);
        ctrl.dataAction = ctrl.getProtectiveEquipment;

        ctrl.init.call(ctrl);
    };

    var watchStatus = watch($ngRedux.getState, 'protectiveEquipment.protectiveEquipmentGrid.filter.location');
    var onChangeLocation = $ngRedux.subscribe(watchStatus(function(newValue) {
        if (ctrl.filter.category) {
            ctrl.getProtectiveEquipmentTypes(ctrl.filter.category, newValue);
        }
        ctrl.$ngRedux.dispatch({
            type: 'SUBTYPE_LIST',
            id: 'equipment',
            data: null
        });
        ctrl.$ngRedux.dispatch({
            type: 'INPUT_SELECT',
            id: 'protectiveEquipmentGrid',
            path: 'filter.type',
            input: null
        });
        ctrl.$ngRedux.dispatch({
            type: 'INPUT_SELECT',
            id: 'protectiveEquipmentGrid',
            path: 'filter.subtype',
            input: null
        });
        ctrl.$ngRedux.dispatch({
            type: 'INPUT_SELECT',
            id: 'protectiveEquipmentGrid',
            path: 'filter.leadEquivalence',
            input: null
        });
    }));

    var watchReset = watch($ngRedux.getState, 'protectiveEquipment.protectiveEquipmentGrid.reset');
    var onReset = $ngRedux.subscribe(watchReset(function() {
        $rootScope.$broadcast('SELECT_CASCADE_RESET', 'personalEquipmentFilterForm');
        ctrl.$ngRedux.dispatch({
            type: 'TYPE_LIST',
            id: 'equipment',
            data: null
        });
        ctrl.$ngRedux.dispatch({
            type: 'SUBTYPE_LIST',
            id: 'equipment',
            data: null
        });
        ctrl.$ngRedux.dispatch({
            type: 'LEAD_EQUIVALENCE_LIST',
            id: 'equipment',
            data: []
        });
    }));

    ctrl.filterActions.onCategorySelected = (event) => {
        ctrl.getProtectiveEquipmentTypes(event.input, ctrl.filter.location);
        ctrl.$ngRedux.dispatch({
            type: 'SUBTYPE_LIST',
            id: 'equipment',
            data: []
        });
        ctrl.$ngRedux.dispatch({
            type: 'INPUT_SELECT',
            id: 'protectiveEquipmentGrid',
            path: 'filter.type',
            input: null
        });
        ctrl.$ngRedux.dispatch({
            type: 'INPUT_SELECT',
            id: 'protectiveEquipmentGrid',
            path: 'filter.subtype',
            input: null
        });
        $ngRedux.dispatch({
            type: 'GRID_RELOAD',
            id: 'protectiveEquipmentGrid'
        });
    };

    ctrl.filterActions.onTypeSelected = (event) => {
        ctrl.getProtectiveEquipmentSubtypes(event.input, ctrl.filter.location);
        ctrl.$ngRedux.dispatch({
            type: 'INPUT_SELECT',
            id: 'protectiveEquipmentGrid',
            path: 'filter.subtype',
            input: null
        });
        $ngRedux.dispatch({
            type: 'GRID_RELOAD',
            id: 'protectiveEquipmentGrid'
        });
    };

    ctrl.$onDestroy = function() {
        onReset();
        onChangeLocation();
        ctrl.destroy();
        ctrl.$ngRedux.dispatch({
            type: 'GRID_RESET',
            id: 'protectiveEquipmentGrid',
        });
        ctrl.$ngRedux.dispatch({
            type: 'TYPE_LIST',
            id: 'equipment',
            data: []
        });
        ctrl.$ngRedux.dispatch({
            type: 'SUBTYPE_LIST',
            id: 'equipment',
            data: []
        });
        ctrl.$ngRedux.dispatch({
            type: 'LEAD_EQUIVALENCE_LIST',
            id: 'equipment',
            data: []
        });
    };
}
